import { useMemo } from 'react';
import { GridColDef } from '@mui/x-data-grid';
import { ColumnConfigItem, CustomColumnDefinition } from '../../types/lead';
import { getDefaultColumnDef } from '../../utils/leads/defaultColumns';
import { getCustomColumnDef } from '../../utils/leads/customColumns';

interface UseLeadGridColumnsProps {
  visibleColumns: ColumnConfigItem[];
  customColumns: CustomColumnDefinition[];
  customStatuses: string[];
  handleStatusChange: (leadId: string, newStatus: string) => void;
  handleSourceChange?: (leadId: string, newSource: string) => void;
  handleCustomFieldChange?: (leadId: string, fieldKey: string, newValue: any) => void;
  onAddOptionToColumn?: (key: string, optionLabel: string) => Promise<any>;
  handleView: (row: any) => void;
  handleEditLead: (row: any) => void;
  handleMessage: (conversationId: string | null) => void;
  onAddCustomLabelClick: (targetLeadId: string) => void;
  leads?: any[];
}

export const useLeadGridColumns = ({
  visibleColumns,
  customColumns,
  customStatuses,
  handleStatusChange,
  handleSourceChange,
  handleCustomFieldChange,
  onAddOptionToColumn,
  handleView,
  handleEditLead,
  handleMessage,
  onAddCustomLabelClick,
  leads = [],
}: UseLeadGridColumnsProps): GridColDef[] => {
  return useMemo<GridColDef[]>(() => {
    return visibleColumns.map((col) => {
      if (col.is_default) {
        return getDefaultColumnDef({
          col,
          customStatuses,
          handleStatusChange,
          handleSourceChange,
          handleView,
          handleEditLead,
          handleMessage,
          onAddCustomLabelClick,
          leads,
        });
      }
      return getCustomColumnDef({
        col,
        customColumns,
        leads,
        handleCustomFieldChange,
        onAddOptionToColumn,
      });
    });
  }, [
    visibleColumns,
    customColumns,
    customStatuses,
    handleStatusChange,
    handleSourceChange,
    handleCustomFieldChange,
    onAddOptionToColumn,
    handleView,
    handleEditLead,
    handleMessage,
    onAddCustomLabelClick,
    leads,
  ]);
};
